import React, { useEffect, useState } from "react";
import { backend } from "../../../../path";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import { CiLocationOn } from "react-icons/ci";
import { PiDeviceMobileThin } from "react-icons/pi";
import { CiMail } from "react-icons/ci";
import { GrFacebookOption } from "react-icons/gr";
import { LiaInstagram } from "react-icons/lia";
import { AiFillYoutube } from "react-icons/ai";
import { RiTwitterXLine } from "react-icons/ri";

function FooterMainNew() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const fetchData = () => {
    setLoading(true);
    fetch(backend + "getcategorywithsubcategory", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCategoryMain = (cat) => {
    // setSubcategory(false)
    navigate(`/category/${cat}`);
    // window.location.reload();
  };
  const handleNavigate = () => {
    navigate("/");
    //scroll to top smoothly
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    console.log("footer called");
  }, []);

  return (
    <>
      <div>
        {authenticated?.usertype === 1 ? (
          <Footer>
            <Wrapper>
              <Container>
                <Section>
                  <ImgContainer onClick={handleNavigate}>
                    <img src="/storage/general/ks-logo32.png" alt="" />
                  </ImgContainer>
                  <P>
                    Shop now to Experience <br /> the Authenticity of Kerala!
                  </P>
                </Section>
                <Section className="links">
                  <List>
                    <Head>Company</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <a href="/about-us">About us</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/contact-us">Contact us</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/blog">Blog</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Categories</Head>
                    <Links>
                      {data &&
                        data.slice(0, -1).map((item, index) => (
                          <Li className="list">
                            {" "}
                            <a href={`/category/${item.category_slug}`}>
                              {item.category_name}
                            </a>
                          </Li>
                        ))}
                    </Links>
                  </List>
                  <List>
                    <Head>Important Links</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/reset-password">Reset Password</Link>
                      </Li>

                      <Li className="list">
                        {" "}
                        <a href="/policy">Terms & Conditions</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/return-refund">Returns & Refund</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Connect With us</Head>
                    <Links>
                      <Li>
                        {/* <CiLocationOn /> */}

                        <a>
                          38, Thycaud Elankom Nagar, <br /> Thycaud , Trivandrum
                          695014
                        </a>
                      </Li>
                      <Li>
                        {/* <PiDeviceMobileThin /> */}

                        <a>+91 - 7356629493 , 8891196910</a>
                      </Li>
                      <Li>
                        {/* <CiMail /> */}

                        <a>info@keralaspecial.in</a>
                      </Li>
                    </Links>
                    <Socials>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                      >
                        <GrFacebookOption />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/keralaspecial/"
                      >
                        <LiaInstagram />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@keralaspecial5256"
                      >
                        <AiFillYoutube />
                      </a>
                      <a
                        target="_blank"
                        href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                      >
                        <RiTwitterXLine />
                      </a>
                    </Socials>
                  </List>
                </Section>
              </Container>
            </Wrapper>
          </Footer>
        ) : authenticated?.usertype === 0 ? (
          <></>
        ) : (
          <Footer>
            <Wrapper>
              <Container>
                <Section>
                  <ImgContainer onClick={handleNavigate}>
                    <img src="/storage/general/ks-logo32.png" alt="" />
                  </ImgContainer>
                  <P>
                    Shop now to Experience <br /> the Authenticity of Kerala!
                  </P>
                </Section>
                <Section className="links">
                  <List>
                    <Head>Company</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/about-us">About us</Link>
                      </Li>
                      <Li className="list">
                        {" "}
                        <Link to="/contact-us">Contact us</Link>
                      </Li>
                      <Li className="list">
                        {" "}
                        <Link to="/blog">Blog</Link>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Categories</Head>
                    <Links>
                      {data &&
                        data.slice(0, -1).map((item, index) => (
                          <Li className="list">
                            {" "}
                            <a href={`/category/${item.category_slug}`}>
                              {item.category_name}
                            </a>
                          </Li>
                        ))}
                    </Links>
                  </List>
                  <List>
                    <Head>Important Links</Head>
                    <Links>
                      <Li className="list">
                        {" "}
                        <Link to="/registration-vendor">
                          Register as vendor
                        </Link>
                      </Li>

                      <Li className="list">
                        {" "}
                        <a href="/policy">Terms & Conditions</a>
                      </Li>
                      <Li className="list">
                        {" "}
                        <a href="/return-refund">Returns & Refund</a>
                      </Li>
                    </Links>
                  </List>
                  <List>
                    <Head>Connect With us</Head>
                    <Links>
                      <Li>
                        {/* <CiLocationOn /> */}

                        <a>
                          38, Thycaud Elankom Nagar, <br /> Thycaud , Trivandrum
                          695014
                        </a>
                      </Li>
                      <Li>
                        {/* <PiDeviceMobileThin /> */}

                        <a>+91 - 7356629493 , 8891196910</a>
                      </Li>
                      <Li>
                        {/* <CiMail /> */}

                        <a>info@keralaspecial.in</a>
                      </Li>
                    </Links>
                    <Socials>
                      <a
                        target="_blank"
                        href="https://www.facebook.com/myKeralaspecial?mibextid=qi2Omg&rdid=kccxW9NpVX3BFzrU&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FXM1oRDDkvagcQKW9%2F%3Fmibextid%3Dqi2Omg"
                      >
                        <GrFacebookOption />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.instagram.com/keralaspecial/"
                      >
                        <LiaInstagram />
                      </a>
                      <a
                        target="_blank"
                        href="https://www.youtube.com/@keralaspecial5256"
                      >
                        <AiFillYoutube />
                      </a>
                      <a
                        target="_blank"
                        href="https://x.com/mykeralaspecial?t=5jaIdWgLfUhVzxywcQto9g"
                      >
                        <RiTwitterXLine />
                      </a>
                    </Socials>
                  </List>
                </Section>
              </Container>
            </Wrapper>
          </Footer>
        )}
      </div>
      <ToastContainer />
    </>
  );
}

export default FooterMainNew;
const Footer = styled.footer`
  background-color: #0d261a;
  padding: 60px 0 40px;
  color: #FDFBF7 !important;
  border-top: 3px solid #D4AF37;
  font-family: 'Jost', sans-serif;
  @media screen and (max-width: 768px) {
    padding: 40px 0 20px;
  }
`;

const Wrapper = styled.div`
  width: 88%;
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    width: 94%;
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 40px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const ImgContainer = styled.div`
  height: 100%;
  width: 192px;
  cursor: pointer;
  
  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
    display: block;
    filter: brightness(0) invert(1); /* Premium white logo against emerald backdrop */
  }

  &.payment {
    height: 30px;
    width: 210px;
    margin: 20px 0;
  }

  @media screen and (max-width: 768px) {
    width: 150px;
  }
`;

const Section = styled.div`
  display: grid;
  gap: 20px;
  justify-items: start;

  &.links {
    grid-template-columns: 1fr 1fr 1.2fr 1.2fr;
    gap: 24px;
    
    @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
    
    @media screen and (max-width: 500px) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
`;

const P = styled.p`
  padding: 0;
  margin: 0;
  font-family: "Playfair Display", serif;
  font-weight: 500;
  font-style: italic;
  font-size: 22px;
  line-height: 140%;
  color: #F2ECE1;
  opacity: 0.95;

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
`;

const Links = styled.ul`
  padding: 0;
  list-style: none;
`;

const Li = styled.li`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 6px 0;
  font-family: "Jost", sans-serif;

  a {
    font-family: "Jost", sans-serif;
    color: #FDFBF7;
    font-size: 14px;
    opacity: 0.8;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      color: #D4AF37;
      opacity: 1;
      padding-left: 4px;
    }
  }

  svg {
    font-size: 18px;
    color: #D4AF37;
  }

  &.list {
    display: block;
    padding: 4px 0;
  }
`;

const Head = styled.h4`
  font-family: "Jost", sans-serif;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 20px;
  color: #D4AF37;
  font-size: 14px;
  line-height: 160%;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`;

const List = styled.div`
  margin-top: 30px;
  
  @media screen and (max-width: 768px) {
    margin-top: 20px;
  }
`;

const Socials = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 20px 0 0;

  a {
    flex-shrink: 0;
    background-color: rgba(212, 175, 55, 0.08);
    border: 1px solid rgba(212, 175, 55, 0.2);
    color: #D4AF37;
    border-radius: 50%;
    padding: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

    &:hover {
      background-color: #D4AF37;
      color: #0d261a;
      transform: translateY(-3px);
      box-shadow: 0 4px 12px rgba(212, 175, 55, 0.2);
    }
  }

  svg {
    font-size: 16px;
  }
`;
